import moment from 'moment';

import { api } from '../../api';
import { GetVouchersFilter } from '../../types/hubTypes';

export const useGetVouchers = (filter?: GetVouchersFilter) => {
  return api.voucher.all.useQuery(filter);
};

export const useGetSoonToExpireVouchers = () => {
  return api.voucher.all.useQuery('Active', {
    select: (vouchers) => {
      if (!vouchers || vouchers.length === 0) {
        return [];
      }
      const today = moment();
      const nearest = vouchers.reduce((nearest, voucher) => {
        const voucherExpiry = moment(voucher.expiryDate);
        if (!nearest) return voucher;
        const nearestExpiry = moment(nearest.expiryDate);
        const voucherDiff = Math.abs(voucherExpiry.diff(today, 'days'));
        const nearestDiff = Math.abs(nearestExpiry.diff(today, 'days'));

        if (voucherDiff !== nearestDiff) {
          return voucherDiff < nearestDiff ? voucher : nearest;
        }

        const voucherIssueDate = moment(voucher.issueDate);
        const nearestIssueDate = moment(nearest.issueDate);
        return voucherIssueDate.isBefore(nearestIssueDate) ? voucher : nearest;
      }, null);
      return nearest ? [nearest] : [];
    },
  });
};
